import { OLAF } from 'HubStyleTokens/colors';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import { useMemo } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const OlafSpan = styled.span.withConfig({
  displayName: "ContentPublishStatus__OlafSpan",
  componentId: "xqf2ba-0"
})(["color:", ";"], OLAF);
const ContentPublishStatus = ({
  isPublished,
  isScheduled,
  publishDate,
  scheduledUpdateDate,
  unpublishDate
}) => {
  const publishStatusOptions = useMemo(() => {
    let publishStatusLangKey = 'draft';
    let statusTagUse = 'draft';
    if (isPublished) {
      if (scheduledUpdateDate) {
        publishStatusLangKey = 'publishedWithScheduledUpdate';
      } else if (unpublishDate) {
        publishStatusLangKey = 'publishedUntil';
      } else {
        publishStatusLangKey = 'published';
      }
      statusTagUse = 'published';
    } else if (isScheduled) {
      publishStatusLangKey = 'scheduled';
      statusTagUse = 'scheduled';
    }
    const scheduledTime = publishDate ? I18n.moment(publishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL') : undefined;
    const unpublishTime = unpublishDate ? I18n.moment(unpublishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL') : undefined;
    const scheduledUpdateTime = scheduledUpdateDate ? I18n.moment(scheduledUpdateDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL') : undefined;
    return {
      dateOptions: {
        scheduledTime,
        unpublishTime,
        scheduledUpdateTime
      },
      publishStatusLangKey,
      statusTagUse
    };
  }, [isPublished, isScheduled, publishDate, scheduledUpdateDate, unpublishDate]);
  return /*#__PURE__*/_jsx(UIStatusTag, {
    use: publishStatusOptions.statusTagUse,
    children: /*#__PURE__*/_jsx(OlafSpan, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `components.header.publishStatus.${publishStatusOptions.publishStatusLangKey}`,
        options: publishStatusOptions.dateOptions
      })
    })
  });
};
export default ContentPublishStatus;